/**
 * Component Registry for Patriot Pointe Townhomes
 *
 * Inherits from @vibesites-amc/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-amc/theme-preferred/registry';
import { ApartmentSyncMapSection } from './components/ApartmentSyncMapSection';
import { FeeGuide } from './components/FeeGuide';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  ApartmentSyncMapSection,
  FeeGuide,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
